
import { Error,  Label,  StyledInput, StyledInputWrapper } from './styled'
import { StadartProps } from './types'

const DEFAULT_WIDTH = '100%'
const DEFAULT_HEIGHT = '60px'

export const Input = ({
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  type = 'text',
  name,
  label,
  isInvalid,
  errorText,
  value,
  ...props
}: StadartProps) => {

  return (
    <>
      <StyledInputWrapper >
        <StyledInput
          autoComplete="off"
          id={name}
          name={name}
          type={type}
          value={value}
          placeholder=" "
          width={width}
          height={height}
          isInvalid={isInvalid}
          {...props}
        />
        {label && (
          <Label  htmlFor={name}>
            {label}
          </Label>
        )}

        {isInvalid && errorText && <Error>{errorText}</Error>}
      </StyledInputWrapper>
    </>
  )
}
